// we're in a deeper folder than fields.js - assume it is loaded
PD.forms.fields.StaticField = (function(){
    function StaticField(cfg, index, form) {
      this._super.apply(this, arguments); // call generic field constructor
    }
    StaticField.prototype = {
      _template: '<div class="form-group">' +
                    '<label for="<%=id%>" class="col-sm-3 control-label"><%=label?label+\':\':\'\'%></label>' +
                    '<div class="cm-static-field <%=classes%> col-sm-<%=helpText? "8" : "9"%>">' +
                      '<input type="hidden" id="<%=id%>" name="<%=name%>">'+
                      '<span class="form-control content"></span>'+
                    '</div>' +
                  '<% if (helpText) { %>' +
                    '<div class="col-sm-1 hidden-xs">' +
                      '<i class="fa fa-question-circle-o" role="button" data-toggle="popover" title="<%=helpText.title%>" data-content="<%=helpText.content%>"></i>'+
                    '</div>' +
                  '<% } %>' +
                  '<% if (errorText) { %>' +
                    '<div class="col-sm-9 col-sm-offset-3 error-text">' +
                      '<p><%=errorText%></p>' +
                    '</div>' +
                  '<% } %>' +
                  '</div>',
      content: "",
      classes: "",
      _feedback: null,
  
      getValue: function(){
        return this.$hidden.val();
      },
      setValue: function(val){
        this.$hidden.val(val);
        this.$content.text(val);
        return true;
      },
      clearValue: function(){
        this.setValue("");
        return true;
      }
    };

    StaticField.prototype._get$Element = function() {
      var $elm = this._super.prototype._get$Element.apply(this);

      this.$hidden = $elm.find("input[type=hidden]");
      this.$content = $elm.find(".content");
      return $elm;
    }
    // inherit from generic field
    PD.forms.fields.register(["static", "StaticField"], StaticField);
  
    return StaticField;
  })();
